define('services/contentTypeService',[
    'lib/lodash4',
    'lib/knockout',
    'services/loggingService',
    'text!strings/contentTypes.json'
], function (_,
             ko,
             LOG,
             unprocessedContentTypes
    ) {
    'use strict';

    var contentTypes;

    var contentTypeService =  {
        /**
         * Gets a friendly name for the mime type
         * @param mimeType
         */
        getName: function (mimeType) {
            var contentType =  this.getContentType(mimeType);

            return contentType ? contentType.name : ko.i18n.renderString("contentType.name.unknown");
        },

        /**
         * Gets the content type object for the mime type
         * @param mimeType
         */
        getContentType: function (mimeType) {
            return _.find(this.getAll(), function (contentType) {
                return contentType.mimeType === mimeType;
            });
        },

        /**
         * Get a list of all content types
         * @returns {*}
         */
        getAll: function () {
            if (!contentTypes) {
                //Process the json file getting the localized name
                contentTypes = _.map(JSON.parse(unprocessedContentTypes), function (contentType) {
                    return {
                        name: ko.i18n.renderString(contentType.nameKey),
                        mimeType: contentType.mimeType
                    };
                });
            }

            return contentTypes;
        }
    };

    return contentTypeService;
});

